<div class="container" style="color: black !important;">
  <div class="heading">
    @if (logoUrl) {
      <img class="header-logo" src="{{logoUrl}}">
    }
    <ng-container>
      <h1 class="waitlist-heading">{{'PrivacyContact.ForQuestions' | translate}}</h1>
    </ng-container>
  </div>
  <div class="main-content">
    <ion-card-content class="card-content">
      <mat-form-field class="form-field-1" appearance="fill">
        <mat-label>{{'PrivacyContact.FirstName' | translate}}</mat-label>
        <input  type="text" matInput [(ngModel)]="firstName">
      </mat-form-field>
    </ion-card-content>
    <ion-card-content class="card-content" style="margin-top: -30px;">
      <mat-form-field class="form-field-1" appearance="fill">
        <mat-label>{{'PrivacyContact.LastName' | translate}}</mat-label>
        <input  type="text" matInput [(ngModel)]="lastName">
      </mat-form-field>
    </ion-card-content>
    <ion-card-content class="card-content" style="margin-top: -30px;">
      <mat-form-field class="form-field-1" appearance="fill">
        <mat-label>{{'PrivacyContact.Email' | translate}}</mat-label>
        <input  type="text" matInput [(ngModel)]="email">
      </mat-form-field>
    </ion-card-content>
    <ion-card-content class="card-content" style="margin-top: -30px;">
      <mat-form-field class="form-field-1" appearance="fill">
        <mat-label>{{'PrivacyContact.PostalCode' | translate}}</mat-label>
        <input  type="text" matInput [(ngModel)]="postalCode" oninput="this.value = this.value.toUpperCase()">
      </mat-form-field>
    </ion-card-content>
    <ion-card-content class="card-content" style="margin-top: -30px;">
      <mat-form-field class="form-field-1" appearance="fill">
        <mat-label>{{'PrivacyContact.Subject' | translate}}</mat-label>
        <input  type="text" matInput [(ngModel)]="subject" [disabled]="true">
      </mat-form-field>
    </ion-card-content>
    <ion-card-content class="card-content" style="margin-top: -30px;">
      <mat-form-field class="form-field-1" appearance="fill">
        <mat-label>{{'PrivacyContact.Details' | translate}}</mat-label>
        <textarea matInput rows="3" [(ngModel)]="details" style="resize: none;" maxlength="1000"></textarea>
      </mat-form-field>
    </ion-card-content>
    <ion-card-content class="bottom-content">
      <button class="submit-btn" type="button" mat-raised-button (click)="submit()"
        [disabled]="firstName == '' || lastName == '' || email == '' || postalCode == '' || subject == '' || details == ''">
        {{'General.Submit' | translate}}
      </button>
    </ion-card-content>
    <ion-card-content class="bottom-link">
      <span (click)="displayPolicies()">{{'PrivacyContact.PrivacyPolicy' | translate}}</span>
    </ion-card-content>
  </div>
</div>
